<template>
  <div v-if="user">
    <div v-if="!enableEdit">
      <div class="border-solid border-2 p-6 rounded-lg" :style="`border-color: #${color}`">
        <div class="flex justify-between mb-3">
          <div class="flex items-center">
            <vs-avatar class="mr-4" size="50px" :src="user.profile_picture" v-if="user && user.profile_picture" />
            <div>
              <h2 class="font-bold">{{ user.full_name }}</h2>
              <p class="font-light">{{ datePosted }} | {{ timePosted }}</p>
            </div>
          </div>
          <div class="pt-1">
            <vs-dropdown class="cursor-pointer" vs-custom-content vs-trigger-click>
              <feather-icon icon="MoreVerticalIcon" svgClasses="h-6 w-6" />

              <vs-dropdown-menu>
                <vs-dropdown-item @click="editPost">Edit</vs-dropdown-item>
                <vs-dropdown-item @click="confirmDeletePost">Delete</vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>
        <div v-html="text" />
      </div>
    </div>
    <vx-card v-if="enableEdit">
      <div class="flex items-center mb-3">
        <vs-avatar class="mr-4" size="50px" :src="user.profile_picture" v-if="user && user.profile_picture" />
        <div>
          <h2 class="font-bold">Edit Post</h2>
          <p class="font-light">{{ datePosted }} | {{ timePosted }}</p>
        </div>
      </div>
      <quill-editor class="mb-3" style="min-height: 175px" v-model="post.post" :options="editorOption" />
      <div class="flex justify-end">
        <vs-button color="danger" class="mr-2 font-bold" @click="enableEdit = false">Cancel</vs-button>
        <vs-button :color="`#${color}`" class="font-bold" @click="updatePost">Update Post</vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'ClassroomStreamPost',
  data () {
    return {
      user: null,
      post: null,
      enableEdit: false,

      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ script: 'sub' }, { script: 'super' }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ align: [] }],
            [{ color: [] }, { background: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean']
          ]
        }
      }
    }
  },
  computed: {
    datePosted () {
      if (this.timestamp) return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric' }).format(this.timestamp)
      return ''
    },
    timePosted () {
      if (this.timestamp) return new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric' }).format(this.timestamp)
      return ''
    }
  },
  components: {
    quillEditor
  },
  props: {
    postId: {
      type: String,
      required: true
    },
    color: {
      type: String
    },
    text: {
      type: String
    },
    author: {
      type: String
    },
    timestamp: {
      type: Number
    }
  },
  methods: {
    confirmDeletePost () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Please confirm you want to delete this post.',
        accept: this.deletePost,
        acceptText: 'Delete'
      })
    },
    deletePost () {
      this.$http
        .delete(`classrooms/posts/${this.postId}`)
        .then((response) => {
          if (response.data.data) {
            this.$emit('refresh')
            this.$vs.notify({
              title: 'Post Delete Successfully',
              text: 'Post has been deleted.',
              color: 'success',
              position: 'bottom-right',
              iconPack: 'feather',
              icon: 'icon-check-circle'
            })
          }
        })
        .catch(() => {
          this.$emit('refresh')
          return this.$vs.notify({
            title: 'Failed To Delete Post',
            text: 'An unknown error occurred while updating this post',
            color: 'danger',
            position: 'bottom-right',
            iconPack: 'feather',
            icon: 'icon-x-circle'
          })
        })
    },
    editPost () {
      this.$http.get(`classrooms/posts/${this.postId}`).then((response) => {
        if (response.status === 200) {
          this.post = response.data.data
          this.enableEdit = true
        }
      })
    },
    fetchUserDetails () {
      this.$httpCached
        .get(`users/${this.author}?cc=classroom_post_user`, { ttl: 15 })
        .then((response) => {
          if (response.status === 200) {
            this.user = response.data.data
          }
        })
        .catch(() => {})
    },
    updatePost () {
      this.$http
        .post(`classrooms/posts/${this.postId}`, this.post)
        .then((response) => {
          if (response.status === 200) {
            this.$emit('refresh')
            this.$vs.notify({
              title: 'Post Updated Successfully',
              text: `${this.post.name} has been updated.`,
              color: 'success',
              position: 'bottom-right',
              iconPack: 'feather',
              icon: 'icon-check-circle'
            })
          }
        })
        .catch((exception) => {
          this.$emit('refresh')
          let error = 'An unknown error occurred while updating this post'
          if (exception.response) {
            error = exception.response.data.error.description
          }
          this.$vs.notify({
            title: 'Failed To Update Post',
            text: error,
            color: 'danger',
            position: 'bottom-right',
            iconPack: 'feather',
            icon: 'icon-x-circle'
          })
        })
    }
  },
  mounted () {
    this.fetchUserDetails()
  }
}
</script>

<style scoped></style>
